import { Menu, MenuList } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import * as React from 'react';
import Modal from '~/components/Modal/Modal';

import { DropdownButton, DropdownList } from '.';

const propTypes = {
  children: PropTypes.oneOfType([PropTypes.func, PropTypes.node]).isRequired,
};

export const DropdownAsModal = ({ children }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  let receivedButton;
  let receivedMenuList;

  // If using it with render props pattern, return children()'s return value
  // Else simply return children
  const realChildren =
    typeof children === 'function' ? children({ isOpen }) : children;

  React.Children.forEach(realChildren, (child) => {
    if (React.isValidElement(child)) {
      if (child.type === DropdownButton) {
        receivedButton = child;
      } else if (child.type === DropdownList) {
        receivedMenuList = child;
      }
    }
  });

  const { as: _as, ...rest } = receivedButton?.props || {};

  // In order to consume the component in the same way on mobile and desktop,
  // we need to create a new button component based on the original passed,
  // so the Menu component doesn't complain about its Button used outside the context
  const newButton = React.createElement(receivedButton?.props?.as || 'button', {
    ...rest,
    onClick: () => setIsOpen((v) => !v),
  });

  return (
    <>
      {newButton}
      <Modal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        modalContentProps={{
          // This resets Popper's positioning styling, which we don't need here because we're using a modal
          css: {
            '& > div': {
              width: '100%',
              position: 'relative !important',
            },
          },
        }}
      >
        <Menu defaultIsOpen closeOnSelect={false} closeOnBlur={false}>
          <MenuList
            position="static"
            borderBottomRightRadius="0"
            borderBottomLeftRadius="0"
            onClick={() => setIsOpen(false)}
            {...receivedMenuList?.props}
          />
        </Menu>
      </Modal>
    </>
  );
};

DropdownAsModal.propTypes = propTypes;
